import { useCallback, useMemo } from "react"
import { ObservationDocument, useObservations } from "../../../contexts/observations-context"

export default () => {
    const { data } = useObservations()

    return useCallback(
        <Type extends string>(type: Type): ObservationDocument<Type>[] => {
            switch (type) {
                case "feeding":
                    return data.filter(
                        (observation): observation is ObservationDocument<Type> =>
                            observation.type === "feeding" && "items" in observation && "totalCount" in observation,
                    )
                case "entry":
                    return useMemo(
                        () =>
                            data.filter(
                                (observation): observation is ObservationDocument<Type> => observation.type === "entry",
                            ),
                        [data],
                    )
                default:
                    return data as ObservationDocument<Type>[]
            }
        },
        [data],
    )
}
